import React from "react";
import { isIOS } from "react-device-detect";
import { withTranslation } from "react-i18next";

import CloseIcon from "./../../images/close-icon.svg";

import "./style.css";

class ModalDownloadApp extends React.Component {
  componentDidMount() {
    document.body.style.overflow = "hidden";
  }

  componentWillUnmount() {
    document.body.style.overflow = "auto";
  }

  downloadApp = (shop_id) => {
    const url = isIOS
      ? `${process.env.REACT_APP_DOWNLOAD_iOS_APP}?shop_id=${shop_id}`
      : `${process.env.REACT_APP_DOWNLOAD_ANDROID_APP}&referrer=id%3D${shop_id}`;
    window.open(url, "_blank");
  };

  render() {
    const { t, color, closeModal, shop_id } = this.props;
    return (
      <div id="download_app_modal">
        <div className="modal_wrapper">
          <div className="modal_header">
            <div className="header_wrapper">
              <div className="title">{t("download_our_app")}</div>
              <div className="close_btn" onClick={closeModal}>
                <img src={CloseIcon} alt="Close button" />
              </div>
            </div>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: t("download_our_app_desc") }}
            ></div>
          </div>
          <div className="modal_footer">
            <div
              className="button"
              onClick={() => this.downloadApp(shop_id)}
              style={{ background: color }}
            >
              {t("btn_download")}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ModalDownloadApp);
